import React, { useState, useEffect } from "react";
import "../App.css";
import { useHistory } from "react-router-dom";
import { Typography, Select } from "antd";
import { List, Button, Picker, Toast } from "antd-mobile";
import { withLocalize } from "react-localize-redux";

const { Title } = Typography;
const { Option } = Select;

const Location = ({ translate }) => {
  const [city, setCity] = useState("");
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const history = useHistory();


  useEffect(() => {
    const savedCity = localStorage.getItem("city");
    const savedLatitude = localStorage.getItem("latitude");
    const savedLongitude = localStorage.getItem("longitude");
    const savedIsLocation = localStorage.getItem("is_location");

    if (savedCity) setCity(savedCity);
    if (savedIsLocation === "true" && savedLatitude && savedLongitude) {
      setPosition({
        latitude: parseFloat(savedLatitude),
        longitude: parseFloat(savedLongitude),
      });
    }
  }, []);

  useEffect(() => {
    if (city) localStorage.setItem("city", city);
  }, [city]);


  useEffect(() => {
    if (position.latitude && position.longitude) {
      localStorage.setItem("latitude", position.latitude);
      localStorage.setItem("longitude", position.longitude);
      localStorage.setItem("is_location", true);
    }
  }, [position]);

  // Handle window resize for mobile/desktop layout
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const allowLocationAccess = () => {
    const savedIsLocation = localStorage.getItem("is_location");
    if (savedIsLocation === "true") {
      Toast.show({ content: translate("location_already_granted"), duration: 2000 });
      return;
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setPosition({
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude,
          });
        },
        () => {
          alert("Location access is blocked. Please allow location access");
          localStorage.setItem("is_location", false);
        }
      );
    } else {
      alert("Geolocation is not supported");
      localStorage.setItem("is_location", false);
    }
  };

  const proceed = () => {
    if (!city) {
      Toast.show({ content: translate("select_city"), duration: 2000 });
    } else if (!position.latitude || !position.longitude) {
      Toast.show({ content: translate("location"), duration: 2000 });
    } else {
      history.push("/home");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        padding: "20px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          backgroundColor: "#FFFFFF",
          width: isMobile ? "90%" : "20%",
          padding: "20px",
          boxSizing: "border-box",
        }}
      >
        <div style={{ width: "100%", maxWidth: "400px" }}>
          <Title level={4} style={{ textAlign: "center" }}>
            {translate("select_place")}
          </Title>

          <List>
            {isMobile ? (
              <List.Item extra={city} clickable onClick={() => setVisible(true)}>
                {translate("city")}
              </List.Item>
            ) : (
              <List.Item>
                <Select
                  placeholder={translate("city")}
                  style={{ width: "100%" }}
                  value={city}
                  onChange={(value) => setCity(value)}
                >
                  <Option value="Karachi">Karachi</Option>
                  <Option value="Lahore">Lahore</Option>
                </Select>
              </List.Item>
            )}

            <List.Item clickable onClick={allowLocationAccess}>
              {translate("location")}
            </List.Item>
          </List>

          <Button block color="primary" size="medium" onClick={proceed}>
            {translate("proceed")}
          </Button>
        </div>

        {isMobile && (
          <Picker
            columns={[
              [
                { label: "Karachi", value: "Karachi" },
                { label: "Lahore", value: "Lahore" },
              ],
            ]}
            visible={visible}
            onClose={() => setVisible(false)}
            value={[city]}
            onConfirm={(v) => setCity(v[0])}
            confirmText={"OK"}
            cancelText={"Cancel"}
          />
        )}
      </div>
    </div>
  );
};

export default withLocalize(Location);
